import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

import { useAuth } from '@pflegia/ui/contexts/auth.context';
import useIsAnalyticsAllowed from '@pflegia/ui/hooks/use-is-analytics-allowed';

import { accessTokenService } from '@shared/utils/access-token.service';

export const useDatadogRum = () => {
  const analyticsAllowed = useIsAnalyticsAllowed();
  const authenticated = useAuth();

  useEffect(() => {
    if (!datadogRum.getInitConfiguration()) return;
    datadogRum.setTrackingConsent(analyticsAllowed ? 'granted' : 'not-granted');
  }, [analyticsAllowed]);

  useEffect(() => {
    if (!datadogRum.getInitConfiguration()) return;
    const userId = authenticated ? accessTokenService.getDecodedToken()?.sub : undefined;
    if (userId) {
      datadogRum.setUser({ id: userId });
    } else {
      datadogRum.clearUser();
    }
  }, [authenticated]);
};
